import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";

import { useFileDndContext } from "./FileDndContext";

export const FileDropOverlay = observer(function FileDropOverlay() {
  const t = useTranslations("documentTree.fileDropOverlay");
  const { isFileDragging, isWindowFileDragging } = useFileDndContext();
  const { dialog } = useStore();

  const hidden =
    !isWindowFileDragging || isFileDragging || dialog.importFromOverleafDialogStore.isOpen;

  return (
    <div
      className={twMerge(
        "absolute inset-0 z-50 pointer-events-none transition-opacity",
        hidden && "opacity-0",
      )}
    >
      <div className="absolute inset-0 bg-white/80 dark:bg-black/80 backdrop-blur-sm border-blue-500 border-[3px] rounded-12" />
      <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
        <Icon name="Drop" />
        <h3 className="text-size-18 m-2 font-semibold text-center">{t("title")}</h3>
        <p className="mt-0 text-size-15 text-gray-500 text-center">{t("description")}</p>
      </div>
    </div>
  );
});
